<template>
  <footer class="footer">
    <div class="footerLink">
      <img class="" src="/frontend/img/logo-c.svg" alt="会社手続きナビゲーター モチカケ">
    </div>
  </footer>
</template>

<script>
export default {
  name: 'f-footer-lp-sub'
}
</script>
